<!--
  Allows to cover the entire screen with a clickable layer, which makes it
  simple to capture click-away events.
-->
<script setup lang="ts">
defineProps<{
  // Whether the layer should be visible (still transparent but dark).
  mask?: boolean
}>()

const emit = defineEmits(['blur'])

function onPointerDown (event: Event) {
  if (!event.defaultPrevented)
    emit('blur', event)
}
</script>

<template>
  <span
    class="blur-area fixed inset-0 overflow-y-auto"
    :class="{ 'bg-black bg-opacity-40': mask }"
    @pointerdown.self="onPointerDown"
  >
    <slot/>
  </span>
</template>
